import React, { memo, useCallback, useState } from 'react'
import { Auth } from '@aws-amplify/auth'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import MuiAlert from '@material-ui/lab/Alert'
import SettingsPanel from '../../components/settings/SettingsPanel'
import Snackbar from '@material-ui/core/Snackbar'
import Typography from '@material-ui/core/Typography'
import LOG from '../../logging/Logger'

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const SettingsAccountDelete = memo(({ onSessionChange, deleteAll }) => {
  LOG.debug('Render: SettingsAccountDelete')

  const [open, setOpen] = useState(false)
  const [lastOpen, setLastOpen] = useState(false)
  const [openAlert, setAlertOpen] = useState(false)

  const handleClickOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handleClickLastOpen = useCallback(() => {
    setOpen(false)
    setLastOpen(true)
  }, [])

  const handleLastClose = useCallback(() => {
    setLastOpen(false)
  }, [])

  const doAccountDeletion = useCallback(() => {
    Promise.all(deleteAll()).then(
      Auth.currentAuthenticatedUser().then(
        user =>
          new Promise((resolve, reject) => {
            user.deleteUser(error => {
              if (error) {
                return reject(error)
              }
              if (onSessionChange) {
                onSessionChange()
              }
              Auth.signOut()
              resolve()
            })
          })
      )
    )
  }, [deleteAll, onSessionChange])

  const deleteAccount = useCallback(() => {
    setLastOpen(false)
    setAlertOpen(true)
    doAccountDeletion()
  }, [doAccountDeletion])

  const handleAlertClose = useCallback(async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setAlertOpen(false)
  }, [])

  return (
    <div>
      <SettingsPanel title='Delete Account'>
        <Typography variant='body1' color='secondary'>
          Warning - This action cannot be undone!
        </Typography>
        <Typography variant='body2' color='inherit'>
          Due to the secure way in which we delete your account, once you choose
          to delete it there is no going back.
        </Typography>
        <br />
        <Button variant='contained' color='secondary' onClick={handleClickOpen}>
          Delete Account
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Delete Account?'}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Are you sure you want to delete your account?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' autoFocus>
              No
            </Button>
            <Button onClick={handleClickLastOpen} color='primary'>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={lastOpen}
          onClose={handleLastClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Last Chance'}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              This is your last chance to avoid irreversably losing all your
              content. Are you absolutely certain you want to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleLastClose} color='primary' autoFocus>
              No
            </Button>
            <Button onClick={deleteAccount} color='primary'>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={openAlert}
          autoHideDuration={6000}
          onClose={handleAlertClose}
        >
          <Alert onClose={handleAlertClose} severity='error'>
            Account deletion initiated
          </Alert>
        </Snackbar>
      </SettingsPanel>
    </div>
  )
})

export default SettingsAccountDelete
